import { Component, Input } from '@angular/core';

@Component({
    selector: 'bws-page-loader',
    template: `
      @if (isLoading) {
        <div class="page-spinner-container">
          <div class="lds-facebook">
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      }
      @if (!isLoading && error) {
        <bws-alert>
          {{error}}
        </bws-alert>
      }
      `,
    styles: [],
    standalone: false
})
/**
 * Page-level loading spinner and error message.
 *
 * Only the spinner is wrapped in `.page-spinner-container`, which is `height: 100%` so
 * the spinner sits in the middle of the page while it is the only thing on it. The error
 * message deliberately is not: it appears *next to* already rendered content, and a
 * second full-height block inside a `h-100` parent doubles that parent's content height.
 * On the subscription wizard that pushed the whole card below the site footer when the
 * validation call failed.
 */
export class PageLoaderComponent {

  @Input() isLoading: boolean = false;
  @Input() error?: string;

}
